import React from 'react';
import { useSelector, connect } from 'react-redux';
import { compose } from 'redux';
import { withFirebase } from 'react-redux-firebase';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Loading from '../components/Loading';
/* eslint-disable react/jsx-filename-extension */

export function RequireAuth({ children }) {
  const auth = useSelector((state) => state.firebase.auth);
  const isInitializing = useSelector((state) => state.firebase.isInitializing);

  if (!auth.isLoaded || isInitializing) {
    return <Loading />;
  }

  if (auth.isEmpty) {
    return <Navigate to="/" replace />;
  }

  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.node.isRequired,
};

export function RequireNoAuth({ children }) {
  const auth = useSelector((state) => state.firebase.auth);
  const isInitializing = useSelector((state) => state.firebase.isInitializing);

  if (!auth.isLoaded || isInitializing) {
    return <Loading />;
  }

  if (!auth.isEmpty) {
    return <Navigate to="/teams" replace />;
  }

  return children;
}

RequireNoAuth.propTypes = {
  children: PropTypes.node.isRequired,
};

const defaultValues = {};

export const profileStateToParams = ({
  firebase: {
    profile,
    auth,
    data: { roles, teams, jugadores },
  },
}) => ({
  profile: {
    idLogged: auth.isLoaded && !auth.isEmpty,
    ...defaultValues,
    ...profile,
    isAdmin: profile.role === 'admon',
    isViewer: profile.role === 'viewer',
    isSuperAdmin: profile.role === 'superAdmin',
    uid: auth.uid,
    ...roles,
  },
  teams,
  jugadores,
});

export const profileOnly = compose(withFirebase, connect(profileStateToParams));
